import z from 'zod';

export const doctorDataForContractSchema = z.object({
  id: z.string(),
  name: z.string(),
  brandName: z.string(),
});

export type DoctorDataForContract = z.infer<typeof doctorDataForContractSchema>;
